import React from "react";
import DivisionGenericSkeleton from "./DivisionGenericSkeleton";

function DivisionDetailSkeleton() {
  return (
    <>
      <DivisionGenericSkeleton />
    </>
  );
}

export default DivisionDetailSkeleton;
